import React, { memo } from "react";
import Pagination from "react-js-pagination";
import { UsePaginationInstanceProps, UsePaginationState } from "react-table";

import styles from "./table.module.scss";

type Props = Pick<UsePaginationInstanceProps<any>, "gotoPage"> &
	UsePaginationState<any> & {
		totalItems: number;
	};

const TableFooter = ({ gotoPage, pageIndex, totalItems, pageSize }: Props) => (
	<div className={styles.footer}>
		<span className={styles.totalRecords}>
			<span className="text-grey">Total Records: </span>
			<span>{totalItems}</span>
		</span>
		<span className={styles.paging}>
			<Pagination
				hideFirstLastPages
				prevPageText="〈 PREV"
				nextPageText="NEXT  〉"
				activePage={pageIndex + 1}
				itemsCountPerPage={pageSize}
				totalItemsCount={totalItems}
				pageRangeDisplayed={1}
				onChange={pageNumber => gotoPage(pageNumber - 1)}
			/>
		</span>
	</div>
);

const Component = memo(TableFooter);
export { Component as TableFooter };
